import { Trans } from 'react-i18next';

export const CsBadgeIcon = () => {
  return (
    <div
      className="mr-[-6px] md:mr-[-10px] mt-[-10px] h-[86px] w-[86px] bg-center bg-no-repeat flex text-center flex-col items-center text-success-mid uppercase text-[8px] leading-[8px] tracking-[1.2px] overflow-hidden font-semibold"
      style={{ backgroundImage: "url('/public/images/donation-100-bg.svg')" }}
    >
      <img src="/public/images/heart-on-palm.gif" alt="donation badge" className="mt-[10px] h-[25px] w-[25px]" />
      <Trans i18nKey="components.Badge100Percent.BadgeText">
        first
        <div className="font-[600] pt-[2px] pb-[2px] tracking-[3px] text-[17px] leading-[17px]">mid</div>
        last
      </Trans>
    </div>
  );
};

export const EnBadgeIcon = () => {
  return (
    <div
      className="mr-[-6px] md:mr-[-10px] mt-[-10px] h-[86px] w-[86px] bg-center bg-no-repeat flex text-center flex-col items-center text-success-mid uppercase text-[8px] leading-[10px] tracking-[1.2px] overflow-hidden font-semibold"
      style={{ backgroundImage: "url('/public/images/donation-100-bg.svg')" }}
    >
      <img src="/public/images/heart-on-palm.gif" alt="donation badge" className="mt-[8px] h-[25px] w-[25px]" />
      <Trans i18nKey="components.Badge100Percent.BadgeText">
        first
        <div className="font-[600]  pb-[1px] tracking-[3px] text-[17px] leading-[17px]">mid</div>
        last
      </Trans>
    </div>
  );
};
